document.addEventListener("DOMContentLoaded", function () {
 
  const btn = document.getElementById("add-membership-with-course");

  if (!btn) return;
 
  let isProcessing = false;
 
  // Ensure only ONE checkbox selected

  document.addEventListener("change", function (e) {

    if (e.target.classList.contains("membership-checkbox")) {

      document.querySelectorAll(".membership-checkbox").forEach(cb => {

        if (cb !== e.target) cb.checked = false;

      });

    }

  });
 
  // Disable button if membership already in cart

  async function checkExistingMembership() {

    try {

      const cart = await fetch('/cart.js').then(r => r.json());
 
      const selected = document.querySelector(".membership-checkbox:checked");

      if (!selected) return;
 
      const variantId = selected.value;
 
      const exists = cart.items.some(i => i.variant_id == variantId);
 
      if (exists) {

        btn.disabled = true;

        btn.innerText = "Already Added";

      } else {

        btn.disabled = false;

        btn.innerText = "Add Membership + Free Course";

      }
 
    } catch (err) {

      console.error("Cart check error", err);

    }

  }
 
  document.addEventListener("change", checkExistingMembership);
 
  btn.addEventListener("click", async function () {
 
    if (isProcessing) return;
 
    const selected = document.querySelector(".membership-checkbox:checked");

    if (!selected) {

      alert("Please select a membership");

      return;

    }
 
    isProcessing = true;
 
    const membershipVariant = selected.value;

    const courseVariant = document.getElementById("course_variant").value;
 
    btn.disabled = true;

    btn.innerText = "Adding...";
 
    try {
 
      // Add membership first

      await fetch('/cart/add.js', {

        method: 'POST',

        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({

          items: [{

            id: membershipVariant,

            quantity: 1,

            properties: { _has_free_course: "true" }

          }]

        })

      });
 
      // Add course

      await fetch('/cart/add.js', {

        method: 'POST',

        headers: { 'Content-Type': 'application/json' },

        body: JSON.stringify({

          items: [{

            id: courseVariant,

            quantity: 1,

            properties: {

              _free_course: "true",

              _linked_membership: membershipVariant

            }

          }]

        })

      });
 
      window.location.href = '/discount/FREECOURSE?redirect=/cart';
 
    } catch (e) {

      console.error(e);

      btn.disabled = false;

      btn.innerText = "Add Membership + Free Course";

      isProcessing = false;

    }

  });
 
});
 